export default __webpack_public_path__ + "static/media/data-center-service.5b2c4a9c.jpg";